import { Col, ControlLabel, Glyphicon } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from 'components/button/Button';
import { FormGroupContainer } from 'components/forms/genericFormField/GenericFormField.styles';
import Tooltip from 'components/tooltip/Tooltip';
import { WebsiteSettingsModalPath } from '../../../DirectBookingEngineTabs.constants';
import { PageNavigationRowStyled } from './NavigationSettings.styles';

const PageNavigationField = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <FormGroupContainer $name="pageNavigation">
      <Col
        componentClass={ControlLabel}
        data-testid="pageNavigation-field-label"
        sm={5}
        xs={4}
      >
        {t('pageDirectBookingEngine.websiteSettings.pageNavigation')}
      </Col>
      <Col sm={7} xs={8}>
        <PageNavigationRowStyled>
          <Button
            bsStyle="link"
            data-testid="add-page-navigation-button"
            onClick={() => navigate(WebsiteSettingsModalPath.navigation)}
          >
            {t('pageDirectBookingEngine.websiteSettings.addPageNavigation')}
          </Button>
          <Tooltip
            id="pageNavigation-tooltip"
            text={t(
              'pageDirectBookingEngine.websiteSettings.pageNavigationTooltip',
            )}
          >
            <Glyphicon
              data-testid="pageNavigation-tooltip-icon"
              glyph="info-sign"
            />
          </Tooltip>
        </PageNavigationRowStyled>
      </Col>
    </FormGroupContainer>
  );
};

export default PageNavigationField;
